import { lmisUrl } from 'config';
import createRequest from '../create-request';

const request = createRequest({ label: 'lmis' });

const getLmis = props => {
  return request
    .timeout(2000)
    .get(lmisUrl)
    .query(props)
    .then(response => {
      return {
        content: response.body,
        lmisType: response.headers['skl-lmis']
      };
    });
};

export default {
  getLmis
};



/** WEBPACK FOOTER **
 ** ./app/wip_modules/seek-jobs-api-client/apis/lmis.js
 **/